// src/Components/CourseCard.jsx
import React, { useEffect, useState } from "react";
import { CARD_GREY, DARK_CARD, TEXT_DARK } from "./utils/constants";
import { pill } from "./utils/ui";

const CourseCard = ({ room, time, title, statusText, accent }) => {
  const initialTheme =
    document.documentElement.getAttribute("data-theme") ||
    localStorage.getItem("eaimTheme") ||
    "light";

  const [theme, setTheme] = useState(initialTheme);

  useEffect(() => {
    const onTheme = (e) => setTheme(e.detail);
    window.addEventListener("eaim-theme", onTheme);
    return () => window.removeEventListener("eaim-theme", onTheme);
  }, []);

  const cardBg = theme === "dark" ? DARK_CARD : CARD_GREY;
  const textColor = theme === "dark" ? "#EDEDED" : TEXT_DARK;
  const statusColor = theme === "dark" ? "#AAB4C8" : "#7A8A97";

  return (
    <div
      style={{
        background: cardBg,
        borderRadius: 16,
        padding: 18,
        minWidth: 240,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        letterSpacing: 1,
        boxShadow: `
          0 8px 12px rgba(0,0,0,0.3),
          0 4px 6px rgba(0,0,0,0.2),
          inset 0 4px 6px rgba(255,255,255,0.3),
          inset 0 -4px 6px rgba(0,0,0,0.25)
        `,
        paddingLeft: "10px",paddingRight: "10px"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
        <div style={{ ...pill(accent), fontSize: 11 }}>ROOM {room}</div>
        <div
          style={{
            ...pill("#ffffff", TEXT_DARK),
            border: "1px solid #d0d7de",
            fontSize: 10,
            background: "#fff",
            fontWeight: "bold",
          }}
        >
          {time}
        </div>
      </div>

      <div style={{ fontWeight: 800, fontSize: 16, color: textColor }}>
        {title}
      </div>

      <div style={{ fontSize: 12, color: statusColor }}>{statusText}</div>
    </div>
  );
};

export default CourseCard;
